import './_two-column.scss';
import component from './two-column';

export default component;
